const PedidoClient = require('@/api/Operacoes/sls-pedidos.client');

export default {
  namespaced: true,
  name: 'pedidoStore',
  state: () => ({
    pedido: {
      pedidoid: null,
      tipopedidoid: null,
      estabelecimentoid: null,
      representanteid: null,
      clienteid: null,
      condicaopagamentoid: null,
      tabelaprecoid: null,
      pedidonumerocliente: null,
      pedidonumerointegracao: null,
      naturezaoperacaoid: null,
      notafiscalserie: null,
      notafiscalnumero: null,
      pedidoobservacoes: null,
      pedidoobservacoeslogistica: null,
      pedidourgente: null,
      usuarioid: null,
      unidadenegocioid: null,
      pedidodata: null,
      pedidodataentrega: null,
      pedidodataentregaprevista: null,
      pedidoentregaperiodo: null,
      pedidoobservacoesnotafiscal: null,
      pedidovalortotal: null,
      transportadoraid: null,
      prazoentrega: null,
      tipofrete: null,
      tipoenderecoid: null,
      pedidonumerorepresentante: null,
      clienteidtriangular: null,
      pedidooccliente: null,
      picid: null,
      pedidositsales: null,
      pedidositsalesdata: null,
      pedidositsalesmsg: null,
      pedidositcomercial: null,
      pedidositcomercialdata: null,
      pedidositcomercialmsg: null,
      pedidositcredito: null,
      pedidositcreditodata: null,
      pedidositcreditomsg: null,
      pedidosaldocancelado: null,
      tabelaprecoiniciovalidade: null,
      pedidoconsumidorfinal: null,
      pedidoalteradoerp: null,
      pedidoalteradoerpusuario: null,
      pedidoalteradoerpdata: null,
      tipousuariopendente: null,
      usuarioidaprovador: null,
      pedidoprioridade: null,
      canalvendaid: null,
      pedidostatusworkflow: null,
      tipoenderecoidtriangular: null,
      portadorid: null,
      portadormodalidade: null,
      moedaid: null,
      cod_priori: null,
      pedidoItens: [],
      pedidoTotal: 0,
      pedidoTotalItens: 0,
    },
    currentPedidoItem: {
      pedidoid: null,
      itemid: null,
      pedidoitemseq: null,
      pedidoitemdatareserva: null,
      pedidoitemquantidade: null,
      pedidoitemprecotabela: null,
      pedidoitemtotalmercadoria: null,
      pedidoitembaseicms: null,
      pedidoitemaliquotaicms: null,
      pedidoitemvaloricms: null,
      pedidoitembaseipi: null,
      pedidoitemaliquotaipi: null,
      pedidoitemvaloripi: null,
      pedidoitembasest: null,
      pedidoitemaliquotast: null,
      pedidoitemvalorst: null,
      pedidoitemvalorfrete: null,
      pedidoitempesobruto: null,
      pedidoitempesoliquido: null,
      pedidoitemquantidadefaturada: null,
      pedidoitemquantidadesaldo: null,
      naturezaoperacaoid: null,
      usuarioidcancelamento: null,
      pedidoitemdatacancelamento: null,
      estabelecimentoidnf: null,
      notafiscalserie: null,
      notafiscalnumero: null,
      empenhoitemdivergencia: null,
      empenhoitemdivergenciamotivo: null,
      tabelaprecovlrminimo: null,
      tabelaprecovlrmaximo: null,
      embarque: null,
      dataembarque: null,
      pedidoitemsaldo: null,
      atualizasaldoestoque: null,
      pedidoitemdeposito: null,
      notafiscaldata: null,
      pedidoitemdataentrega: null,
      pedidoitemdataentregaprevista: null,
      pedidoitempercdesc: null,
      picid: null,
      pedidoitemsitcomercial: null,
      pedidoitemsitcomercialdata: null,
      pedidoitemsaldocancelado: null,
      pedidoitemprecovenda: null,
      pedidoitemaliquotaiss: null,
      pedidoitembaseiss: null,
      pedidoitemvaloriss: null,
      pedidoitemaliquotaiva: null,
      pedidoitembaseiva: null,
      pedidoitemvaloriva: null,
      pedidoitemaliquotapis: null,
      pedidoitembasepis: null,
      pedidoitemvalorpis: null,
      pedidoitemaliquotacofins: null,
      pedidoitembasecofins: null,
      pedidoitemvalorcofins: null,
      referenciaid: null,
      pedidoitemorigemks: null,
      pedidoitemorigemems: null,
      pedidoitemdescontozf: null,
      pedidoitemqtalocada: null,
      tipoped: null,
      pedidoitemprecounitario: null,
      pedidoitemaliquotaicmsreducao: null,
    },
  }),
  mutations: {
    UPDATE_ITEM_QUANTITY(state, { item, quantity }) {
      const picAtivo = this?.getters?.['preferencias/picAtivo'] === true;
      const items = state.pedido && state.pedido.pedidoItens;
      if (!items) return;
      const picIdentity = (value) => {
        const id = value.pic_id ?? value.picid;
        if (id !== null && id !== undefined && String(id) !== '' && String(id) !== '0') return `pic:${id}`;
        return value.item_pic_promocao ? 'pic:unknown' : 'normal';
      };
      const itemIndex = items.findIndex((i) => i.item_id === item.item_id
                && i.cdn_cor === item.cdn_cor
                && i.cdn_tamanho === item.cdn_tamanho
                && (!picAtivo || (picIdentity(i) === picIdentity(item)
                && String(i.cdn_embalag ?? i.cdn_embalagem ?? '')
                  === String(item.cdn_embalag ?? item.cdn_embalagem ?? ''))));

      if (itemIndex !== -1) {
        const updatedItem = { ...items[itemIndex], pedido_item_quantidade: quantity };

        updatedItem.valor_total = parseFloat(updatedItem.pedido_item_preco_unitario * quantity).toFixed(2);
        updatedItem.pedido_item_preco_total = Number(updatedItem.valor_total);
        updatedItem.valorTotalComImposto = parseFloat(updatedItem.precoComImposto * quantity).toFixed(2);

        items.splice(itemIndex, 1, updatedItem);
      }
    },
    UPDATE_PIC_ITEM_PRICES(state, updates) {
      const items = state.pedido && state.pedido.pedidoItens;
      if (!items || !Array.isArray(updates)) return;
      // Validate the whole response before touching any line.
      updates.forEach((update) => {
        if (!Number.isFinite(Number(update.precoTabelaErp)) || Number(update.precoTabelaErp) <= 0
          || !Number.isFinite(Number(update.pedido_item_preco_unitario))
          || Number(update.pedido_item_preco_unitario) <= 0
          || !Number.isFinite(Number(update.precoComImposto)) || Number(update.precoComImposto) <= 0
          || !Number.isFinite(Number(update.pedido_item_quantidade))
          || Number(update.pedido_item_quantidade) < 1) {
          throw new Error('Preço ERP de tabela, preço final ou quantidade inválidos para a promoção.');
        }
      });
      updates.forEach((update) => {
        const itemIndex = items.findIndex((item) => (
          String(item.pic_id ?? item.picid) === String(update.pic_id ?? update.picid)
          && String(item.item_id ?? item.itemId) === String(update.item_id ?? update.itemId)
          && String(item.cdn_cor ?? '') === String(update.cdn_cor ?? '')
          && String(item.cdn_tamanho ?? '') === String(update.cdn_tamanho ?? '')
          && String(item.cdn_embalag ?? item.cdn_embalagem ?? '')
            === String(update.cdn_embalag ?? update.cdn_embalagem ?? '')
        ));
        if (itemIndex === -1) return;

        const item = items[itemIndex];
        const quantidade = Number(update.pedido_item_quantidade);
        const preco = Number(update.pedido_item_preco_unitario);
        const precoComImposto = Number(update.precoComImposto);
        if (!Number.isFinite(quantidade) || quantidade < 1
          || !Number.isFinite(preco) || preco <= 0
          || !Number.isFinite(precoComImposto) || precoComImposto <= 0) {
          throw new Error('Preço ou quantidade inválidos para a promoção.');
        }

        Object.assign(item, {
          pedido_item_quantidade: quantidade,
          picitemquantidade: quantidade,
          pedido_item_preco_unitario: preco,
          picitemvalorpic: preco,
          valor_total: +(preco * quantidade).toFixed(2),
          precoComImposto,
          pedido_item_preco_tabela_erp: Number(update.precoTabelaErp),
          valorTotalComImposto: +(precoComImposto * quantidade).toFixed(2),
          base_icms: update.base_icms ?? update.baseIcms ?? item.base_icms ?? 0,
          valor_icms: update.valor_icms ?? update.valorIcms ?? item.valor_icms ?? 0,
          natureza_operacao_id_imposto: update.natureza_operacao_id_imposto
            ?? update.naturezaoperacaoidimposto
            ?? item.natureza_operacao_id_imposto
            ?? 0,
          picitemdesconto: update.picitemdesconto,
          picitemfaixa: update.picitemfaixa,
          picitemquantidadetotal: update.picitemquantidadetotal,
        });
      });
    },
    SET_PEDIDO(state, pedido) {
      state.pedido = pedido;
    },
    ADD_OR_UPDATE_PRODUCT_ITEM_PEDIDO(state, product) {
      console.log('ADD_OR_UPDATE_PRODUCT_ITEM_PEDIDO', product);
      const picAtivo = this?.getters?.['preferencias/picAtivo'] === true;
      const picIdentity = (item) => {
        const id = item.pic_id ?? item.picid;
        if (id !== null && id !== undefined && String(id) !== '' && String(id) !== '0') return `pic:${id}`;
        return item.item_pic_promocao ? 'pic:unknown' : 'normal';
      };
      const index = state.pedido.pedidoItens.findIndex((item) => item.des_tamanho === product.des_tamanho
                && item.cdn_cor === product.cdn_cor
        && (!picAtivo || String(item.item_id ?? '') === String(product.item_id ?? ''))
                && item.familia_comercial_id === product.familia_comercial_id
                && item.cdn_embalag === product.cdn_embalag
                // A normal line (0) and a PIC line must remain separate.  A
                // second addition of the same PIC/SKU, on the other hand,
                // belongs to the existing line and is repriced below.
                && (!picAtivo || picIdentity(item) === picIdentity(product)));
      if (index !== -1) {
        const item = state.pedido.pedidoItens[index];
        // Compatibility for tenants without PIC: retain the existing line's
        // approved/current price, rather than applying PIC cumulative repricing.
        if (!picAtivo) {
          if (item.item_pic_promocao) {
            state.pedido.pedidoItens.push(product);
            return;
          }
          const quantity = Number(item.pedido_item_quantidade || 0)
            + Number(product.pedido_item_quantidade || 0);
          const price = Number(item.pedido_item_preco_unitario || 0);
          const taxPrice = Number(item.precoComImposto || price);
          item.pedido_item_quantidade = quantity;
          item.valor_total = +(price * quantity).toFixed(2);
          item.valorTotalComImposto = +(taxPrice * quantity).toFixed(2);
          item.pedido_item_preco_total = +(price * quantity).toFixed(2);
          return;
        }
        const quantidadeAtual = Number(item.pedido_item_quantidade || 0);
        const quantidadeNova = Number(product.pedido_item_quantidade || 0);
        const novaQuantidade = quantidadeAtual + quantidadeNova;
        item.pedido_item_quantidade = novaQuantidade;
        // PIC quantity tiers can change the unit price when another
        // quantity is added.  Prefer the newly calculated line price and
        // retain the previous price only for legacy lines that do not carry
        // one.
        const precoUnitario = Number(product.pedido_item_preco_unitario || item.pedido_item_preco_unitario || 0);
        const precoComImposto = Number(product.precoComImposto || item.precoComImposto || precoUnitario);
        Object.assign(item, {
          pedido_item_preco_unitario: precoUnitario,
          pedido_item_preco_unitario_base: product.pedido_item_preco_unitario_base
            ?? item.pedido_item_preco_unitario_base,
          picitemvalorpic: product.picitemvalorpic ?? item.picitemvalorpic,
          picitemdesconto: product.picitemdesconto ?? item.picitemdesconto,
          picitemfaixa: product.picitemfaixa ?? item.picitemfaixa,
          picitemquantidadetotal: product.picitemquantidadetotal ?? novaQuantidade,
          precoComImposto,
          pedido_item_preco_tabela_erp: product.pedido_item_preco_tabela_erp ?? item.pedido_item_preco_tabela_erp,
          valor_total: +(precoUnitario * novaQuantidade).toFixed(2),
          valorTotalComImposto: +(precoComImposto * novaQuantidade).toFixed(2),
          pedido_item_preco_total: +(precoUnitario * novaQuantidade).toFixed(2),
        });
      } else {
        state.pedido.pedidoItens.push(product);
      }
    },
    REMOVE_PRODUCT_ITEM_PEDIDO(state, payload) {
      const picIdentity = (item) => {
        const id = item.pic_id ?? item.picid;
        if (id !== null && id !== undefined && String(id) !== '' && String(id) !== '0') return `pic:${id}`;
        return item.item_pic_promocao ? 'pic:unknown' : 'normal';
      };
      const index = state.pedido.pedidoItens.findIndex((item) => item.des_tamanho === payload.des_tamanho
        && item.cdn_cor === payload.cdn_cor
        && String(item.item_id ?? '') === String(payload.item_id ?? '')
        && picIdentity(item) === picIdentity(payload)
        && String(item.cdn_embalag ?? item.cdn_embalagem ?? '')
          === String(payload.cdn_embalag ?? payload.cdn_embalagem ?? ''));
      if (index !== -1) {
        state.pedido.pedidoItens.splice(index, 1);
      }
    },
    SET_CART_ITEMS(state, products) {
      state.cartItems = products;
    },
    REMOVER_ITEM_PIC_PROMOCAO(state) {
      state.pedido.pedidoItens = state.pedido.pedidoItens.filter((info) => !info.item_pic_promocao);
    },
  },
  getters: {
    getTotalPedidoComImposto: (state) => state.pedido.pedidoItens.reduce((acc, item) => acc + (parseFloat(item.precoComImposto || 0) * parseFloat(item.pedido_item_quantidade || 0)), 0).toFixed(2),
    getPedido: (state) => state.pedido,
    getItemPedido: (state) => state.pedido.pedidoItens,
    getTotalPedido: (state) => state.pedido.pedidoItens.reduce((acc, item) => acc + Number(item.valor_total || 0), 0),
    getTotalItensPedido: (state) => state.pedido.pedidoItens.reduce((acc, item) => acc + Number(item.pedido_item_quantidade || 0), 0),
    getLastSequenceItemPedido: (state) => {
      const lastItem = state.pedido.pedidoItens[state.pedido.pedidoItens.length - 1];
      return lastItem ? lastItem.pedido_item_seq : 0;
    },
  },
  actions: {
    clearPedidoAndItemPedido({ commit }) {
      commit('SET_PEDIDO', {
        pedidoid: null,
        tipopedidoid: null,
        estabelecimentoid: null,
        representanteid: null,
        clienteid: null,
        condicaopagamentoid: null,
        tabelaprecoid: null,
        pedidonumerocliente: null,
        pedidonumerointegracao: null,
        naturezaoperacaoid: null,
        notafiscalserie: null,
        notafiscalnumero: null,
        pedidoobservacoes: null,
        pedidoobservacoeslogistica: null,
        pedidourgente: null,
        usuarioid: null,
        unidadenegocioid: null,
        pedidodata: null,
        pedidodataentrega: null,
        pedidodataentregaprevista: null,
        pedidoentregaperiodo: null,
        pedidoobservacoesnotafiscal: null,
        pedidovalortotal: null,
        transportadoraid: null,
        prazoentrega: null,
        tipofrete: null,
        tipoenderecoid: null,
        pedidonumerorepresentante: null,
        clienteidtriangular: null,
        pedidooccliente: null,
        picid: null,
        pedidositsales: null,
        pedidositsalesdata: null,
        pedidositsalesmsg: null,
        pedidositcomercial: null,
        pedidositcomercialdata: null,
        pedidositcomercialmsg: null,
        pedidositcredito: null,
        pedidositcreditodata: null,
        pedidositcreditomsg: null,
        pedidosaldocancelado: null,
        tabelaprecoiniciovalidade: null,
        pedidoconsumidorfinal: null,
        pedidoalteradoerp: null,
        pedidoalteradoerpusuario: null,
        pedidoalteradoerpdata: null,
        tipousuariopendente: null,
        usuarioidaprovador: null,
        pedidoprioridade: null,
        canalvendaid: null,
        pedidostatusworkflow: null,
        tipoenderecoidtriangular: null,
        portadorid: null,
        portadormodalidade: null,
        moedaid: null,
        cod_priori: null,
        pedidoItens: [],
        pedidoTotal: 0,
        pedidoTotalItens: 0,
      });
      commit('SET_CURRENT_PEDIDO_ITEM', {
        pedidoid: null,
        itemid: null,
        pedidoitemseq: null,
        pedidoitemdatareserva: null,
        pedidoitemquantidade: null,
        pedidoitemprecotabela: null,
        pedidoitemtotalmercadoria: null,
        pedidoitembaseicms: null,
        pedidoitemaliquotaicms: null,
        pedidoitemvaloricms: null,
        pedidoitembaseipi: null,
        pedidoitemaliquotaipi: null,
        pedidoitemvaloripi: null,
        pedidoitembasest: null,
        pedidoitemaliquotast: null,
        pedidoitemvalorst: null,
        pedidoitemvalorfrete: null,
        pedidoitempesobruto: null,
        pedidoitempesoliquido: null,
        pedidoitemquantidadefaturada: null,
        pedidoitemquantidadesaldo: null,
        naturezaoperacaoid: null,
        usuarioidcancelamento: null,
        pedidoitemdatacancelamento: null,
        estabelecimentoidnf: null,
        notafiscalserie: null,
        notafiscalnumero: null,
        empenhoitemdivergencia: null,
        empenhoitemdivergenciamotivo: null,
        tabelaprecovlrminimo: null,
        tabelaprecovlrmaximo: null,
        embarque: null,
        dataembarque: null,
        pedidoitemsaldo: null,
        atualizasaldoestoque: null,
        pedidoitemdeposito: null,
        notafiscaldata: null,
        pedidoitemdataentrega: null,
        pedidoitemdataentregaprevista: null,
        pedidoitempercdesc: null,
        picid: null,
        pedidoitemsitcomercial: null,
        pedidoitemsitcomercialdata: null,
        pedidoitemsaldocancelado: null,
        pedidoitemprecovenda: null,
        pedidoitemaliquotaiss: null,
        pedidoitembaseiss: null,
        pedidoitemvaloriss: null,
        pedidoitemaliquotaiva: null,
        pedidoitembaseiva: null,
        pedidoitemvaloriva: null,
        pedidoitemaliquotapis: null,
        pedidoitembasepis: null,
        pedidoitemvalorpis: null,
        pedidoitemaliquotacofins: null,
        pedidoitembasecofins: null,
        pedidoitemvalorcofins: null,
        referenciaid: null,
        pedidoitemorigemks: null,
        pedidoitemorigemems: null,
        pedidoitemdescontozf: null,
        pedidoitemqtalocada: null,
        tipoped: null,
        pedidoitemprecounitario: null,
        pedidoitemaliquotaicmsreducao: null,
      });
    },
    removeProductFromCart({ commit }, productId) {
      commit('REMOVE_PRODUCT_FROM_CART', productId);
    },
  },
};
